export type PersonalBusinessDetails = {
  personalBusinessClassificationDetailsByClient: {
    ledgerAccounts: LedgerAccount[];
    dataEntries: DataEntryResponse;
    unclassifiedEntriesCount: number;
    classifiedEntriesCount: number;
  };
};

export type LedgerAccount = {
  id: string;
  name: string;
};

type DataEntryResponse = {
  searchMarker: string;
  pageInfo: PageInfo;
  dataEntries: DataEntry[];
};

type PageInfo = {
  total: number;
  hasNextPage?: boolean;
  endCursor?: string;
};

export type DataEntry = {
  id: string;
  amount: number;
  journalEntry: JournalEntry;
  ledgerAccount: LedgerAccount;
};

type JournalEntry = {
  id: string;
  vendorName: string;
  dateOfTransaction: string;
  classification: JournalEntryClassification;
};

type JournalEntryClassification = {
  id: string;
  value: JournalEntryClassificationValue;
  state: JournalEntryClassificationState;
};

export type JournalEntryClassificationValue = 'PERSONAL' | 'BUSINESS';

type JournalEntryClassificationState =
  | 'PENDING'
  | 'CONFIRMED_BY_CLIENT'
  | 'RECLASSIFIED_BY_BENCH'
  | 'SUGGESTED_BY_BENCH'
  | 'ACCEPTED_SUGGESTION'
  | 'SELECTED_BY_CLIENT';

export type DataEntriesSort = {
  field:
    | 'DATE_OF_TRANSACTION'
    | 'VENDOR_NAME'
    | 'AMOUNT'
    | 'LEDGER_ACCOUNT_NAME'
    | 'CLASSIFICATION_VALUE';
  direction: 'ASC' | 'DESC';
};

export type ReviewTransactionFilters = {
  search: string | null;
  accounts: LedgerAccount[] | null;
  startDate: Date;
  endDate: Date;
  classification: JournalEntryClassificationValue | null;
};

export type DataEntryRowDataType = {
  id: string;
  date: Date;
  description: string;
  ledgerAccount: LedgerAccount;
  classification: JournalEntryClassification;
  amount: number;
};

// Mutation Types
export interface ClassifyPersonalBusinessDataEntriesInput {
  searchMarker?: string;
  clientId: string;
  dataEntryIds: string[];
  classificationValue: JournalEntryClassificationValue;
}

export interface ClassifyPersonalBusinessDataEntriesVariables {
  input: ClassifyPersonalBusinessDataEntriesInput;
  skipDataEntries: boolean;
}

export interface ClassifyPersonalBusinessDataEntriesResult {
  classifyPersonalBusinessDataEntries: {
    numberOfDataEntriesClassified: number;
    dataEntries?: DataEntry[];
  };
}

export interface ConfirmPersonalBusinessClassificationInput {
  searchMarker: string;
  clientId: string;
  dataEntryIds: string[];
  classificationValueToConfirm: JournalEntryClassificationValue;
}

export interface ConfirmPersonalBusinessClassificationsVariables {
  input: ConfirmPersonalBusinessClassificationInput;
}

export interface ConfirmPersonalBusinessClassificationsResult {
  confirmPersonalBusinessClassifications: {
    numberOfDataEntriesConfirmed: number;
  };
}
